<script>
import RawData from "@/components/widgets/raw-data.vue";
export default {
  props: {
    records: {},
    type: {
      type: String,
      default: 'pending'
    }
  },
  components: { RawData },
  data() {
    return {
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filterOn: [],
      sortBy: "company.name",
      sortDesc: false,
      tableBusy: false,
    };
  },
  computed: {
    rows() {
      return this.records.length;
    },
    fields(){
      let data = [
        {
          key: "rfpNumber",
          label: "RFP Number",
          sortable: true,
        },
        {
          key: "payee",
          label: "Payee",
          sortable: true,
        },
        {
          key: "particulars",
          label: "Particulars",
          sortable: true,
        },
        {
          key: "deliveryUnitBudgetItem",
          label: "Allotment Charging",
          sortable: true,
        },
        {
          key: "rfpDate",
          label: "RFP Date",
          sortable: true,
        },
        {
          key: "rfpDate",
          label: "RFP Date",
          sortable: true,
        },
        {
          key: "amount",
          label: "Amount",
        },
      ];
      if(this.type.toLowerCase() === 'pending'){
        data.push({
          key: "action",
          label: "Action",
          thStyle: { width: "90px", textAlign: "center" },
          tdClass: ['text-center']
        }); 
      }
      return data;
    }
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    postPayment(record){
      this.$emit('post-payment', record);
    },
    printRFP(id){
      this.$emit('print-rfp', id);
    },
    updateItem(item) {
      this.$emit('edit-item', item);
    },
    deleteItem(item) {
      this.$emit('delete-item', item);
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex justify-content-between">
          <label class="d-inline-flex align-items-center">
            Search:
            <b-form-input
              autocomplete="off"
              v-model="filter"
              type="search"
              placeholder="Search..."
              class="form-control form-control-sm ms-2"
            ></b-form-input>
          </label>
          <button
            v-if="type.toLowerCase() === 'pending'"
            type="button"
            class="btn btn-sm btn-purple mt-2"
            @click="$emit('create-rfp')"
          >
            <i class="bx bx-plus"></i> Create Request
          </button>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-lg-12">
        <div class="table-responsive mb-0">
          <b-table
            class="datatables"
            :items="records"
            :fields="fields"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
            :busy="tableBusy"
            @filtered="onFiltered"
            bordered
            outlined
            hover
            striped
            show-empty
          >
            <template #empty="scope">
              <div class="text-center">{{ scope.emptyText }}</div>
            </template>
            <template #table-busy>
              <div class="d-flex justify-content-center align-items-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-20px h-20px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(action)="row">
              <b-dropdown
                id="dropdown-dropleft"
                right
                variant="link"
                toggle-class="text-decoration-none"
                menu-class="dropdown-menu-end"
                no-caret
            >
                <template #button-content>
                    <i class="fas fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item
                  @click="updateItem(row.item)"
                  variant="secondary"
                  ><i class="mdi mdi-update font-size-18 me-1"></i
                  >Edit</b-dropdown-item
                >
                <b-dropdown-item
                  @click="deleteItem(row.item)"
                  variant="danger"
                  ><i
                      class="mdi mdi-trash-can font-size-18 me-1"
                  ></i
                  >Delete</b-dropdown-item
                >
                <b-dropdown-item
                  @click="postPayment(row.item)"
                  variant="info"
                  ><i class="mdi mdi-check font-size-18 me-1"></i
                  >Post Request</b-dropdown-item
                >
                <b-dropdown-item
                  @click="printRFP(row.item.id)"
                  variant="purple"
                  ><i class="mdi mdi-printer font-size-18 me-1"></i
                  >Print Request</b-dropdown-item
                >
            </b-dropdown>
            </template>
            <template #cell(amount)="row">
              <span class="text-warning">{{ formatCurrency(row.item.amount) }}</span>
            </template>
            <template #cell(rfpDate)="row">
              <span>{{ formatDate(new Date(row.item.rfpDate)) }}</span>
            </template>
            <template #cell(payee)="row">
              <span>{{ row.item.payee }}</span>
              <small class="d-block">{{ row.item.payeeAddress }}</small>
            </template>
            <template #cell(rfpNumber)="row">
              <div class="position-relative">
                <RawData 
                  :data="row.item" 
                  v-if="$store.state.decrypt.isAdmin()" 
                />
              <span>{{ row.item.rfpNumber }}</span>
              </div>
            </template>
          </b-table>
        </div>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
